import styled from 'styled-components';
import {themecolors} from "../utils/themecolors";
import useWindowDimensions, {useDimensions, useVideoDimensions} from "../utils/dimensions";
import {useScoredMedia} from "../utils/host";
import ViewableImage from "./viewable_image";
import VideoPlayer from "./video_player";
import ErrorBoundary from "./error_boundary";
import TweetEmbed from "./tweet_embed";
import LinkExcerpt from "./link_excerpt";
import ExternalLink from "./external_link";
import PlaceholderLinkExcerpt from "./placeholder_link_excerpt";
import TextContent from "./text_content";

const StyledViewableImage = styled(ViewableImage)``;
const StyledLinkExcerpt = styled(LinkExcerpt)``;
const StyledVideo = styled.video``;
const StyledImg = styled.img``;
const StyledPlaceholderLinkExcept = styled(PlaceholderLinkExcerpt)``;

const Content = styled.div``;
const ContentPreview = styled.div``;

const VideoContainerOuter = styled.div``;
const VideoContainerInner = styled.div``;

const PostExpand = styled(({className, post, inFeed, expand}) => {

    const windowWidth = useWindowDimensions().width - 32;
    const compressedMedia = post?.media.resized_resolutions[0] || false;
    const isScoredMedia = useScoredMedia(post?.link);
    const dimensions = useDimensions(windowWidth, compressedMedia?.width || 0, compressedMedia?.height || 0);
    const contentType = compressedMedia?.["content-type"];

    const videoDimensions = useVideoDimensions(post?.media, windowWidth);
    const isVideo = post?.is_video || post?.link_metadata?.rumble_embed;
    const isVidey = post?.is_video && !post?.is_video_mp4 && post.video_link.startsWith("https://cdn.videy.co/");
    const iframeLink = post && !isVidey && ((post.is_video && !post.is_video_mp4 && post.video_link) || post.link_metadata?.rumble_embed);

    const isMetadata = (!post?.content && !isVideo && !post?.is_image && !post?.is_twitter && !post?.is_crosspost) && (post && post?.link_metadata?.title);
    const isPlaceholderLink = post && !post?.content && !isVideo && !post?.is_image && !post?.is_twitter && !post?.is_crosspost && !isMetadata;

    return (
        <div className={className} style={{paddingTop: expand ? '4px' : '0'}}>


            {(compressedMedia && contentType !== 'mp4') &&
            <StyledViewableImage post={post} style={{height: dimensions[1], width: dimensions[0]}} viewable={!inFeed}
                           title={post.title} preview={`https://media.scored.co${compressedMedia.reference}`}
                           src={post.link} author={post.author} community={post.community} alt="post"/>}

            {compressedMedia && contentType === 'mp4' &&
            <StyledVideo autoPlay loop muted playsInline
                   style={{height: dimensions[1], width: dimensions[0]}}>
                <source src={`https://media.scored.co${compressedMedia.reference}`} type="video/mp4"
                        referrerPolicy="no-referrer"/>
                Your browser does not support the video tag.</StyledVideo>
            }

            {!compressedMedia && post?.is_image && isScoredMedia && <StyledImg src={post.link}/>}

            {(post?.content && inFeed) &&
                <Content><ContentPreview><TextContent content={post.content} removalSource={post?.removal_source}
                                                      type={"Post"}/></ContentPreview></Content>
            }

            {(post?.content && !inFeed) &&
                <Content><TextContent content={post.content} removalSource={post?.removal_source} type={"Post"}/></Content>
            }

            {(isVideo && !post?.is_video_mp4 && !isVidey) &&
                <VideoContainerOuter style={{height: videoDimensions[0], width: videoDimensions[1]}}>
                    <VideoContainerInner>
                        <iframe src={iframeLink} frameBorder="0" allowFullScreen="" allow="fullscreen;"
                                title={post.title} referrerPolicy="no-referrer"/>
                    </VideoContainerInner>
                </VideoContainerOuter>
            }

            {isVideo && (post?.is_video_mp4 || isVidey) &&
                <VideoPlayer onClick={(e) => {
                    e.stopPropagation()
                }} src={`${post.video_link}`} inPost={!inFeed}/>
            }

            {post?.is_twitter && post.link_metadata?.twitter && (
                <ErrorBoundary>
                    <TweetEmbed data={post.link_metadata.twitter}/>
                </ErrorBoundary>
            )}

            {isMetadata && (inFeed ? <StyledLinkExcerpt data={post.link_metadata} domain={post.domain}/>
                    :
                    <ExternalLink href={post.link}>
                        <StyledLinkExcerpt data={post.link_metadata} domain={post.domain}/>
                    </ExternalLink>
            )
            }

            {isPlaceholderLink && !inFeed &&
                    <ExternalLink href={post.link}>
                        <StyledPlaceholderLinkExcept post={post}/>
                    </ExternalLink>
            }


        </div>
    );
})`
  
  width: calc(100% - 32px);
  margin: 0 auto;
  margin-bottom: 4px;
  
  ${StyledViewableImage},
  ${VideoContainerInner},
  ${StyledLinkExcerpt},
  ${StyledVideo},
  ${StyledImg} {
    border-radius: 12px;
    margin-top: 8px;
  }

  ${StyledViewableImage},
  ${VideoContainerInner},
  ${StyledVideo},
  ${StyledImg} {
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : themecolors.lightest_border};
  }
  
  ${StyledImg},
  ${StyledViewableImage} {
    transform: translateZ(0);
  }
  
  ${Content},
  ${StyledPlaceholderLinkExcept} {
    margin-top: 8px;
  }
  
  ${StyledVideo} {
    margin: 0 auto;
    margin-top: 8px;
  }
  
  ${VideoContainerOuter} {
    max-width: 560px;
    margin: 0 auto;
  }
  
  ${VideoContainerInner} {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 560px;
  }

  ${VideoContainerInner} iframe,
  ${VideoContainerInner} object,
  ${VideoContainerInner} embed { 
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  iframe {
    display: flex;
    margin: 0 auto;
  }

  video {
    max-width: 100%;
  }

  ${Content} {
    font-size: 14px;
    padding: 0 0px 6px 0px;
    overflow-x: hidden;
    border-radius: 4px;
  }
  ${Content} p:last-of-type {
    margin-bottom: 0;
  }
  ${ContentPreview} {
    font-size: 14px;
    max-height: 106px;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    ${({theme: { isSafari }}) => !isSafari && `
    display: -webkit-box;
    -webkit-line-clamp: 5; /* number of lines to show */
    -webkit-box-orient: vertical;
    `}
  }
  ${ContentPreview}:after {
    content: "";
    position: absolute;
    top: 100px;
    width: 100%;
    left: 0;
    height: 8px;
    background: linear-gradient(rgba(0,0,0,0), ${({theme}) => theme.color.name === 'dark' ? `${themecolors.dark_background_1}` : theme.white_0});
  }
  
`;

export default PostExpand;
